import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccessLevels, getRoles, getUserList, postNewUserDetails,getAssetVisibility, editUserDetails ,deleteUser} from "../../config/services/ApiServices";

export const fetchUserList = createAsyncThunk('user-list/fetch', async () => {
    const response = await getUserList();
    return response;
})

export const fetchAccessLevels = createAsyncThunk('access-levels/fetch', async ({ customerId }: { customerId: string, }) => {
    const response = await getAccessLevels(customerId);
    return response;
})

export const fetchUserRoles = createAsyncThunk('user-roles/fetch', async ({ customerId }: { customerId: string, }) => {
    const response = await getRoles(customerId);
    return response;
})

export const saveNewUserDetails = createAsyncThunk('post-new-user-details', async ({ userDetails }: { userDetails: any, }) => {
    const response = await postNewUserDetails(userDetails);
    return response;
})

export const fetchAssetVisibility = createAsyncThunk('asset-visibility/fetch', async ({ customerId }: { customerId: string, }) => {
    const response = await getAssetVisibility(customerId);
    return response;
})

export const editUserData = createAsyncThunk('edit-user-details', async ({ userDetails }: { userDetails: any, }) => {
    const response = await editUserDetails(userDetails);
    return response;
})

export const deleteUserData = createAsyncThunk('delete-user-details', async ({ userDetails }: { userDetails: any, }) => {
    const response = await deleteUser(userDetails);
    return response;
})